/**
 * Hand-off between the insert actions (which run in the browser, then
 * redirect back to the editor) and the editor's Undo toast: the API returns a
 * snapshot of the insert, we park it in localStorage, and the next page load
 * shows "N inserted · Undo" for a few seconds.
 *
 * Undo only lives for that toast — a stale entry is ignored (STALE_MS) and the
 * toast clears it when it closes, so a refresh afterwards offers nothing.
 */
const KEY = "exerciseInsertUndo.v1";
/** Ignore an entry older than this (a redirect never takes this long). */
const STALE_MS = 30000;

/** Fired on window after saveInsertUndo: the editor usually stays mounted
 * across the redirect, so its Undo toast listens instead of only reading on mount. */
export const INSERT_UNDO_EVENT = "exercise-insert-undo-saved";

export const saveInsertUndo = ({ snapshot, count }) => {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ snapshot, count, createdAt: Date.now() })
    );
    window.dispatchEvent(new Event(INSERT_UNDO_EVENT));
  } catch {
    // storage unavailable (private window): the insert still worked, no Undo
  }
};

/** @returns {{ snapshot: object, count: number }|null} */
export const readInsertUndo = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry?.snapshot || Date.now() - entry.createdAt > STALE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return entry;
  } catch {
    return null;
  }
};

export const clearInsertUndo = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
};
